<template>
  <ValidationProvider :name="$attrs.name" :rules="rules" v-slot="{ valid, errors }">
    <b-form-group v-bind="$attrs">
      <b-form-radio-group
        :state="errors[0] ? false : (valid ? true : null)"
        v-model="innerValue"
        stacked
        style="column-count: 2;"
      >
        <slot/>
      </b-form-radio-group>
      <b-form-invalid-feedback v-if="errors.length > 0" id="inputLiveFeedback" style="display:block">{{ errors[0] }}</b-form-invalid-feedback>
    </b-form-group>
  </ValidationProvider>
</template>


<script>
export default {
  props: {
    vid: {
      type: String
    },
    rules: {
      type: [Object, String],
      default: ""
    },
    value: {
      type: null
    }
  },
  data: () => ({
    innerValue: ""
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  }
};
</script>
